/* global APP, JitsiMeetJS, config, interfaceConfig */
import { handleResponse } from './handle-response';

export const getRooms = identifier => {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.hosts.api_url}/rooms/`, requestOptions)
            .then(handleResponse);
};


export const getEventData = identifier => {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.hosts.api_url}/rooms/get-event-webapp/${identifier}/?query={id,name, default_transcription_enabled}`, requestOptions)
            .then(handleResponse);
};

export const attachMessages = data => {
    const requestOptions = {
        method: 'POST',
        body: data
    };

    return fetch(`${config.hosts.api_url}/rooms/events/messages/`, requestOptions)
            .then(handleResponse);
};

export const eventControl = data => {
    const requestOptions = {
        method: 'POST',
        body: data
    };

    return fetch(`${config.hosts.api_url}/rooms/events/controls/`, requestOptions)
            .then(handleResponse);
};

export const participantsUpdate = (participantID, formData) => {
    const requestOptions = {
        method: 'PUT',
        body: formData
    };

    return fetch(`${config.hosts.api_url}/rooms/events/participants/${participantID}/`, requestOptions)
            .then(handleResponse);
};
